<template>
  <b-modal
    ref="newConversationModal"
    modal-class="new-conversation-modal"
    size="md"
    hide-header-close
    @shown="autoFocus"
    @hidden="resetData">
    <!-- Modal Title -->
    <template #modal-title>
      <div class="flex">
        Send
        <SBIcon
          class="ml-1 mr-1"
          :icon="SBIconList.WHATSAPP_LOGO_THICK"
          :color="SBColors.blackPrimary"
          :size="14" />
        New Message
      </div>
    </template>
  <!-- <div>
    <div class="text-message">
    <div class="keyword-input">
      <span class="slash">/</span>
      <b-input
      ref="keywordInput"
      v-model="keyword"
      v-validate="'required'"
      name="keyword"
      type="text"
      data-vv-as="Keyword"
      placeholder="Add Keyword"
      @keydown.native="preventSpace"/>
      <span
      v-if="errors.has('keyword')"
      class="validation-error">{{ errors.first('keyword') }}</span>
      <span
      v-if="validationErrors.keyword"
      class="validation-error">{{ validationErrors.keyword }}</span>
    </div>
    <div>
      <MessageTextArea
      ref="messageArea"
      :enter-submit="false"
      class="mt-3"
      placeholder="Enter text here..."/>
    </div>
    <span
      v-if="validationErrors.text"
      class="validation-error">{{ validationErrors.text }}</span>
    </div>
    <b-button
    :class="{loading: saving}"
    :disabled="saving"
    class="btn-round btn-block mt-4 mb-3"
    @click="saveReply">
    <span v-if="!saving">Save</span>
    <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </div> -->
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import setValidationErrors from '@/helpers/validationErrors';
import MessageTextArea from '../../../common/MessageTextArea';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';

// TODO remove from conversation header and make static on messages

export default {
  name: 'NewConversationModal',
  components: {
    MessageTextArea,
    SBIcon,
  },
  data() {
    return {
      validationErrors: {},
      errorMessage: '',
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      apiError: 'chat/apiError',
    }),
  },
  watch: {
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data ? error.data.message : '';
      }
    },
  },
  methods: {
    ...mapActions({
    }),
    show() {
      this.$refs.newConversationModal.show();
    },
    hide() {
      this.resetData();
      this.$refs.newConversationModal.hide();
    },
    autoFocus() {
    //   this.$refs.keywordInput.focus();
    },
    preventSpace(e) {
      if (e.which === 32) {
        e.preventDefault();
      }
    },
    resetData() {
    //   Object.assign(this.$data, this.$options.data.apply(this));
    //   this.$refs.messageArea.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .new-conversation-modal {
  .modal-title {
    .icon {
      top: 2px;
      position: relative;
    }
  }
}
</style>
